import './form-modal.css';

function FormModal({ showModal, onClose = () => {}, children }) {
    if (!showModal)
        return;

    return (
        <>
            <div className='background-block'></div>

            <div className='form-modal container glass-effect-15'>
                <button onClick={onClose} id="close-form-modal"><i></i></button>
                
                {children}
            </div>
        </>
    );
}

export default FormModal;